export default {
  hi_im_neela: 'Hallo, ik ben Neela,',
  english: 'English',
  german: 'Deutsch',
  french: 'Français',
  dutch: 'Nederlands',
  swedish: 'Svenska',
  ukrainian: 'Українці',
  turkish: 'Türkçe',
  russian: 'Русский',
  spanish: 'Español',
  italian: 'Italiano',
  arabic: 'عربي',
  polish: 'Polska',
  aareons_virtual: 'Aareon´s Virtuele Assistent.',
  media: 'Media',
  media_link: 'https://neela.aareon.com/media',
  contact: 'Contact',
  contact_link: 'https://neela.aareon.com/contact',
  privacy: 'Gegevensbescherming',
  privacy_link: 'https://www.aareon.com/sixcms/detail.php/3627',
  terms_of_use: 'Gebruiksvoorwaarden',
  terms_of_use_link: 'https://www.aareon.com/sixcms/detail.php/3621',
  legal_notice: 'Afdruk',
  legal_notice_link: 'https://neela.aareon.com/legal',
  show_system_messages: 'Toon systeemberichten',
  dont_show_system_messages: 'Verberg systeem berichten',
  logged_in: 'Huurder is geverifieerd',
  logged_out: 'Anonieme gebruiker',
  button_switch_locale: 'Verander taal',
  button_tooltip_activate_voice_recognition: 'Activeer stemherkenning',
  date_input: 'Selecteer datum',
  choose_two_dates: 'Kies twee datums',
  date_range: 'Datumbereik',
  from: 'van',
  to: 'naar',
  avatar: 'Avatar',
  exit: 'Einde',
  new: 'Nieuw',
  back: 'Terug',
  suggestions: 'Suggesties',
  senton: 'Verzonden op',
  message_placeholder: 'Vul hier je bericht in',
  comment_placeholder: 'Geef hier uw commentaar',
  file_max_upload_text: 'Er kunnen maximaal 20 bestanden worden geüpload',
  message_button_label: 'Sturen',
  please_confirm: 'Bevestig alstublieft',
  no: 'Nee',
  yes: 'Ja',
  modal_delete_session: 'Sessie verwijderen',
  modal_delete_session_notification:
    'Als u het venster sluit, wordt uw sessie ook verwijderd.<br>Bent u het hiermee eens?',
  template_contact_time: 'Wanneer mogen we contact met u opnemen?',
  template_pause:
    'Je sessie werd gepauzeerd. Een van onze supportmedewerkers zal uw aanvraag binnenkort in behandeling nemen.',
  template_continue_after_pause:
    'Uw sessie werd voortgezet. U kunt nu verder schrijven met onze chatbot.',
  button_apply: 'Bevestigen',
  button_cancel: 'Afbreken',
  none: 'Geen',
  book_appointment: 'Boek een datum',
  address_input: 'Adresvermelding',
  data_processing: 'Gegevensverwerking',
  privacy_policy: 'Privacybeleid',
  data_processing_notification_before_link:
    'Om gebruik te maken van deze chatdienst is het noodzakelijk dat u het ',
  data_processing_notification_after_link: 'accepteert.',
  button_accept: 'Accepteer',
  select_date: 'Selecteer datum',
  rate_conversation: 'Hoe zou u dit gesprek waarderen?',
  new_ticket_question: 'Kan ik U nog ergens anders mee van dienst zijn?',
  thank_you:
    'Dank u voor uw steun. Jouw feedback helpt me om mezelf voortdurend te verbeteren.',
  goodbye: 'Tot ziens',
  start_new: 'Start nieuw gesprek',
  operator_entered_the_chat: 'Operator entered the chat',
  operator_left_the_chat: 'Operator has left the chat',
  bg_image: process.env.VUE_APP_NL_BG,
  expand_quickreplies: 'Meer',
  collapse_quickreplies: 'Minder',
  login: 'Inloggen',
  logout: 'Uitloggen',
  close: 'Sluiten',
  maximize: 'Maximize',
  minimize: 'Minimize',
  feedback_helpful: 'Dit antwoord hielp me',
  feedback_not_helpful: 'Dit antwoord hielp me niet',
  chatProtocol: 'ChatProtocol',
  showMore: 'Toon meer',
  showLess: 'Toon minder',
  uploadTooltip: 'Upload bestand',
  uploadFilesTooltip: 'Upload bestanden',
  pdfDownloadTooltip: 'Download Gesprek',
  feedbackDescription: 'Feedback aan ons',
  feedbackSubtitle: {
    description:
      'Hier kunt u ons algemene suggesties, voorstellen en verzoeken sturen.',
    note: 'Houd er rekening mee dat wij deze niet kunnen beantwoorden.',
    hint:
      'Alle andere zorgen die specifiek betrekking hebben op uw huurwoning of het zoeken naar een appartement kunt u ons in de chat beschrijven.'
  },
  feedbackPlaceholder: 'Vul hier uw bericht in...',
  sendFeedback: 'Stuur',
  giveFeedback: 'Feedback aan ons',
  feedbackSubmittedSuccessfully: 'Uw feedback is succesvol verzonden',
  thanks: 'Bedankt'
}
